import { PoolFactory } from '@base/pool/PoolFactory'
import { SymbolSpineAnimation } from '../SymbolSpineAnimation'
import { SymbolContainerData } from '@/modules'

export class SymbolsAnimationFactory extends PoolFactory {
    public constructor() {
        super(SymbolSpineAnimation)
    }

    public getAnimationResource(): string {
        return null
    }

    public getAnimationLabel(symbolData: SymbolContainerData, state: string): string {
        return this.getAnimationFormat().replace('{state}', state)
    }

    public getAnimationFormat(): string {
        return '{state}'
    }

    public createSymbol(): SymbolSpineAnimation {
        return new SymbolSpineAnimation(this)
    }
}
